import '../common/_sidebar';